import debounce from 'lodash.debounce';
import { disableBodyScroll } from 'body-scroll-lock';
import { addDesktopListener } from '@/utils/breakpoint';
import { toggleElementClass, toggleElementClassConditionally } from '@/utils/dom-helpers';

export const primaryNavigation = {
  mounted(sitePrimaryNavigation) {
    const primaryNavigationLinks = sitePrimaryNavigation.querySelectorAll('[data-primary-item]');
    const siteMenu = sitePrimaryNavigation.closest('.js-site-menu');
    const siteSubmenuItems = siteMenu ? Array.from(siteMenu.querySelectorAll('[data-primary-subitem]')) : [];
    const siteSubmenuBackButtons = siteMenu.querySelectorAll('[data-subitem-back]');
    const secondaryNavigationLinks = siteMenu.querySelectorAll('[data-secondary-item]');
    const siteHeader = document.querySelector('.js-header');

    const mouseOverListeners = [];
    const clickListeners = [];

    addDesktopListener((isDesktop) => {
      primaryNavigationLinks.forEach((primaryLink, index) => {
        if (isDesktop) {
          if (clickListeners[index]) primaryLink.removeEventListener('click', clickListeners[index]);
          const mouseOverListener = () => activateSubmenu(primaryLink);
          primaryLink.addEventListener('mouseover', mouseOverListener);
          mouseOverListeners[index] = mouseOverListener;
        } else {
          if (mouseOverListeners[index]) primaryLink.removeEventListener('mouseover', mouseOverListeners[index]);
          const clickListener = (e) => {
            e.preventDefault();
            activateSubmenu(primaryLink);
          };
          primaryLink.addEventListener('click', clickListener);
          clickListeners[index] = clickListener;
        }
      });
    });

    calculatePrimaryNavigationTopOffset();
    window.addEventListener('resize', debounce(calculatePrimaryNavigationTopOffset, 250), { passive: true });

    secondaryNavigationLinks.forEach((link) => {
      link.addEventListener('mouseover', hideActiveSubmenu);
    });

    siteSubmenuBackButtons.forEach((backButton) => {
      backButton.addEventListener('click', hideActiveSubmenu);
    });

    siteMenu.addEventListener('menustatechange', ({ detail }) => {
      if (!detail.isMenuActive) {
        hideActiveSubmenu();
      }
    });

    function activateSubmenu(primaryLink) {
      const correspondingSubmenuItem = siteSubmenuItems.find(
        (item) => item.dataset.primarySubitem === primaryLink?.dataset.primaryItem,
      );
      if (correspondingSubmenuItem) {
        disableBodyScroll(correspondingSubmenuItem);
      }

      toggleSubmenuState(primaryLink, true);
    }

    function hideActiveSubmenu() {
      const activeSubmenuItem = siteSubmenuItems.find((item) => item.classList.contains('is-active'));
      if (activeSubmenuItem) {
        activeSubmenuItem.scrollTop = 0;
      }

      toggleSubmenuState(null, false);
    }

    function toggleSubmenuState(primaryLink, activate) {
      const isSameLink = (navigationLink) => navigationLink === primaryLink;
      toggleElementClassConditionally(primaryNavigationLinks, isSameLink, 'is-active');
      toggleElementClass(sitePrimaryNavigation, activate, 'is-active');

      if (!siteMenu || !siteSubmenuItems.length) {
        return;
      }

      toggleElementClass(siteMenu, activate, 'is-submenu-active');
      toggleElementClass(siteHeader, activate, 'is-submenu-active');
      const isMatchingSubItem = (item) => item.dataset.primarySubitem === primaryLink?.dataset.primaryItem;
      toggleElementClassConditionally(siteSubmenuItems, isMatchingSubItem, 'is-active');
    }

    function calculatePrimaryNavigationTopOffset() {
      siteMenu.style.setProperty(
        '--site-menu-primary-navigation-top-offset',
        `${sitePrimaryNavigation.offsetTop}px`,
      );
    }
  },
};
